import React from 'react';
import Header from "../../Components/Header/Header";
import Sidebar from "../../Components/Sidebar/Sidebar";
import Exam from '../../Components/Certifications/Exam/Exam';
import DashboardRightSection from '../../Components/DashboardRightSection/DashboardRightSection';

function ExamPage() {
  return (
    <div className="BallotsPage">
      <div className="ballotsPageContainer">
        <div className="headerContain">
          <Header />
        </div>
        <div className="ballotsPageContainer2">
          <div className="sidebarContain">
            <Sidebar />
          </div>
          <div className="middleContainer">
            <Exam />
          </div>
          <div className="dashboardRightSectionContain">
            <DashboardRightSection />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExamPage;
